import React, { useEffect } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
};
export function Drawer({
  open,
  onClose,
  title,
  children,
  footer
}: Props) {
  const reduced = useReducedMotion();
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-120" data-mp="bfc4w4diyluk">
      {open && <div className="fixed inset-0 z-[60]" role="dialog" aria-modal="true" aria-label={title} data-id="element-121" data-mp="gfgpa5hk00q2">
          <motion.button type="button" aria-label="Sluiten" onClick={onClose} className="absolute inset-0 h-full w-full cursor-default bg-ink/35" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-122" data-mp="kgioimbh0cs1" />
          <motion.aside className="absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-shell shadow-xl" initial={reduced ? {
        opacity: 0
      } : {
        x: '100%'
      }} animate={reduced ? {
        opacity: 1
      } : {
        x: 0
      }} exit={reduced ? {
        opacity: 0
      } : {
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-123" data-mp="2835k7m0qvb11">
            <header className="flex items-center justify-between border-b border-line px-6 py-5" data-id="element-124" data-mp="2qxu2kgdlicll">
              <h2 className="font-display text-xl text-ink" data-id="element-125" data-mp="2lz9cvavyzbbe">{title}</h2>
              <button type="button" onClick={onClose} aria-label="Sluiten" className="-mr-2 rounded-full p-2 text-muted transition-colors duration-150 ease-soft hover:bg-sand hover:text-ink" data-id="element-126" data-mp="3ji2bz3obcec3">
                <XIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-127" data-mp="1hrlfql3tsiof" />
              </button>
            </header>
            <div className="flex-1 overflow-y-auto px-6 py-6" data-id="element-128" data-mp="131e70x3mee0x">{children}</div>
            {footer && <div className="border-t border-line px-6 py-5" data-id="element-129" data-mp="180qspeir9f1x">{footer}</div>}
          </motion.aside>
        </div>}
    </AnimatePresence>;
}